module.exports = __webpack_public_path__ + "img/8.84df0f91.png";